module.exports = __webpack_public_path__ + "img/call-center-ac@3x.1bb0061f.png";